module.exports = __webpack_public_path__ + "img/Logo_white_orj.43aa16b1.png";